import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/template/${number | ':templateId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/template/:templateId`;

export const URL = (templateId: number): RouteDefinition => `${baseRoute}/template/${templateId}`;
